// converteix text pla (com el que s'edita a "Dades bancàries" a la gestió) a HTML segur
// per mostrar-lo amb dangerouslySetInnerHTML: escapa qualsevol tag que hi hagi al text
// (evita HTML/XSS involuntari), converteix les URLs en enllaços clicables i els salts de
// línia en <br />, perquè no calgui escriure'ls a mà com a HTML dins del text
export function textPlaAHtml(text) {
  if (!text) return { __html: '' }

  const escapat = String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  const ambEnllacos = escapat.replace(
    /(https?:\/\/[^\s<]+)/g,
    (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
  )

  const ambSalts = ambEnllacos.replace(/\n/g, '<br />')

  return { __html: ambSalts }
}

// per a camps que ja es desen com a HTML complet, editats amb l'editor de text enriquit de
// la gestió (p.ex. les condicions de pagament): es mostren tal qual, sense escapar ni
// convertir res, ja que el propi editor és qui produeix aquest HTML
export function htmlDesat(html) {
  return { __html: html ?? '' }
}
